import { useLocalStorage } from "@vueuse/core";

/** Drafts are stored in this browser only, so their settings are not synced with the server either. */
const keepDraftOnCancel = useLocalStorage<boolean>("settings.drafts.keepOnCancel", true);

export function useDraftSettings() {
  return { keepDraftOnCancel };
}
